import { Icon, Row, Text } from '@amzn/meridian';
import type { DesktopTokens } from '@amzn/meridian-tokens/base/icon/desktop';
import type { PhoneMobileTokens } from '@amzn/meridian-tokens/base/icon/phone-mobile';
import type { FC } from 'react';
import { getFlagIcon } from './getFlagIcon';

type LocaleRowProps = {
  countryCode?: string;
  icon?: DesktopTokens | PhoneMobileTokens;
  text: string;
};

export const LocaleRow: FC<LocaleRowProps> = ({ countryCode, icon, text }) => {
  const renderIcon = () => {
    if (countryCode) {
      return getFlagIcon({
        countryCode,
        height: 15,
      });
    }
    if (icon) {
      return <Icon tokens={icon} />;
    }
    return null;
  };

  return (
    <Row spacing="300">
      {renderIcon()}
      <Text type="b200">{text}</Text>
    </Row>
  );
};
